/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import {
  Grid,
  Container,
  Button,
  Typography,
  CardContent,
  Card,
  Badge,
  withStyles,
  Switch,
} from "@material-ui/core";
import PageTitle from "../../components/pageTitle/PageTitle";
import CommonContext from "../../hooks/commonContext";
import { Bell, Mail, MessageSquare } from "lucide-react";
import { getGroupsList } from "../../services/apiservices/groups";
import {
  getEmployeesList,
} from "../../services/apiservices/employee";
import confirm from "../../components/DialogComponent/confirm";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { useNavigate } from "react-router";
import { saveNotification } from "../../services/apiservices/notifications";
import AuthContext from "../../hooks/authContext";
import { getSettings } from "../../services/apiservices/settings";
import { packageAccess } from "../../services/helpers";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import styles from "./notification.module.scss";
import { useMediaQuery } from "@mui/material";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textArea";
import { Checkbox } from "../../components/ui/checkbox";
import { useToast } from "../../hooks/useToast";
import SingleSelectNew from "../../components/SelectField/SingleSelectNew";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import moment from "moment";

const RecipientType = ({ recipientType }) => {
  switch (recipientType) {
    case "employee":
      return (
        <PersonOutlineOutlinedIcon
          style={{ color: "rgb(59 130 246 / 1)" }}
          fontSize=""
        />
      );
    case "client":
      return (
        <ApartmentOutlinedIcon
          fontSize=""
          style={{ color: "rgb(34 197 94 / 1)" }}
        />
      );
    case "group":
      return (
        <GroupOutlinedIcon
          fontSize=""
          style={{ color: "rgb(168 85 247 / 1)" }}
        />
      );
    default:
      return (
        <PersonOutlineOutlinedIcon
          style={{ color: "rgb(59 130 246 / 1)" }}
          fontSize=""
        />
      );
  }
};

const RecipientList = ({
  options,
  formdata,
  recipientType,
  handlefieldChange,
}) => {
  const selectedRecipients =
    recipientType === "employee"
      ? formdata?.selectedEmployees || []
      : recipientType === "group"
      ? formdata?.selectedGroup
        ? formdata.selectedGroup
        : []
      : [];

  const handleRecipientSelect = (recipient) => {
    if (recipientType === "employee") {
      let newSelected = [...(formdata?.selectedEmployees || [])];
      const exists = newSelected?.find((r) => r.id === recipient.value.id);

      if (exists) {
        newSelected = newSelected?.filter((r) => r.id !== recipient.value.id);
      } else {
        newSelected.push(recipient.value);
      }
      handlefieldChange("selectedEmployees", newSelected);
    } else if (recipientType === "group") {
      let newSelected = [...(formdata?.selectedGroup || [])];
      const exists = newSelected?.find((g) => g?.groupId === recipient?.value?.groupId);

      if (exists) {
        newSelected = newSelected?.filter((g) => g?.groupId !== recipient?.value?.groupId);
      } else {
        newSelected.push(recipient.value);
      }
      handlefieldChange("selectedGroup", newSelected);
    }
  };


const handleSelectAll = (options) => {
  const allSelected = options?.map((item) => item.value);

  if (recipientType === "employee") {
    const isAllSelected = formdata?.selectedEmployees?.length === options?.length;
    handlefieldChange("selectedEmployees", isAllSelected ? [] : allSelected);
  } else if (recipientType === "group") {
    const isAllSelected = formdata?.selectedGroup?.length === options?.length;
    handlefieldChange("selectedGroup", isAllSelected ? [] : allSelected);
  }
};

  const isSelected = (recipient) => {
    if (recipientType === "employee") {
      return selectedRecipients?.some(
        (r) => r?.id === (recipient?.value?.id || recipient?.id)
      );
    } else if (recipientType === "group") {
      return selectedRecipients?.some(
        (r) => r?.groupId === (recipient?.value?.groupId || recipient?.groupId)
      );
    }
    return false;
  };
  return (
    <div className={`${styles.listContainer} dark:border-0  dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] `}>
      {options?.length > 0 ? (
        <>
          <div
            className={styles.selectAll}
            onClick={() => handleSelectAll(options)}
          >
            <span className="font-medium dark:text-[#6B7280]">Select All</span>
            <Badge
              variant={
                options.every((opt) => isSelected(opt)) ? "success" : "outline"
              }
            >
              <span className="dark:text-white">{options?.filter((opt) => isSelected(opt)).length}/{options?.length}</span>
            </Badge>
          </div>

          {options?.map((option, idx) => (
            <div
              key={idx}
              className={`${styles.recipientItem} ${
                isSelected(option) ? `${styles.selectedItem} dark:bg-[#0F1729] dark:text-white` : ""}
                ${recipientType === "client" && option?.employeeCount === 0 ? styles.disabledItem : ""} dark:hover:bg-gray-700 hover:bg-gray-100
                `}
              onClick={() => {
                if (!(recipientType === "client" && option?.employeeCount === 0)) {
                  handleRecipientSelect(option);
                }
              }}
            >
              <div className={styles.recipientInfo}>
                <PersonOutlineOutlinedIcon fontSize="small" className="dark:text-white"/>
                <span className="dark:text-white">{option.label}</span>
              </div>
              {isSelected(option) && (
                <Badge variant="success" className={styles.selectedBadge}>
                  Selected
                </Badge>
              )}
            </div>
          ))}
        </>
      ) : (
        <div className="color-danger" style={{fontSize:"14px", fontWeight:"500"}}>
          {recipientType === "group" ? "You must add at least 1 employee to this group." : "There are no team members active. Please contact your administrator"} 
          </div>
      )}
    </div>
  );
};

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);

function CreateNotification(props) {
  const commonContext = useContext(CommonContext);
  const history = useNavigate();
  const { toast } = useToast();
  const [formerror, setFormError] = useState({});
  const [formdata, setFormData] = useState({});
  const [type, setType] = useState("employee");
  const [audienceList, setAudienceList] = useState([]);
  const [audienceName, setAudienceName] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [, setGetEmpby] = useState(false);
  const [, setGetCliby] = useState(true);
  const [scheduled, setSCheduled] = useState(false);
  const [scheduleTime, setScheduleTime] = useState();
  const [scheduleDate, setScheduleDate] = useState();
  const [clientList, setClientList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [messageOptionsList, setMessageOptionsList] = useState([]);
  const setIsLoading = (status) => {
    commonContext.setLoader(status);
  };
  const isMobile = useMediaQuery("(max-width:767px)");
  const auth = useContext(AuthContext);
  const localCompanyId = localStorage.getItem('companyId');
  const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const userPackageId = auth?.userProfile?.prdId;
  const allowedPermissions = packageAccess(userPackageId);
  const hasSMSAccess = allowedPermissions?.routes?.includes("SMS_NOTIFICATION");
  const companyName = `${auth?.userProfile?.companyData?.data?.companyName}`;

  const clearformdata = () => {
    setFormData({});
    setFormError({});
    setGetEmpby("");
    setGetCliby("");
    setSCheduled(false);
    setScheduleDate();
    setScheduleTime();
    setAudienceList([]);
    setAudienceName([]);
  };

  const resetFormStates = () => {
    setFormError({});
    setFormData({});
    setType("employee");
    setAudienceList([]);
    setAudienceName([]);
    setGetEmpby(false);
    setGetCliby(true);
    setSCheduled(false);
    setScheduleTime(undefined);
    setScheduleDate(undefined);
    setClientList([]);
    setGroupList([]);
    setEmployeeList([]);
    setMessageOptionsList([]);
  };

  const TypeOptions = [
    { label: "Name", value: "employee" },
    { label: "Group", value: "group" },
  ];

  const fetchData = async () => {
    setIsLoading(true);
    let Emps = [];
    await getEmployeesList(
      {},
      (res) => {
        if (res) {
          const details = res?.filter((item)=> item?.companyId === companyId && item?.status !== false);
          setEmployees(details);
          const data = res?.filter((item) => {
            const isActive = item?.status !== false;
            const isSameCompany = item?.companyId === companyId;
            if (!isActive || !isSameCompany) return false;
            return true;
          });
          Emps = data;
          let allEmp = data?.map((eitem) => {
            return {
              ...eitem,
              userName: `${eitem?.firstName} ${eitem?.lastName}`,
            };
          });
          setEmployeeList(allEmp);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      },
      (resError) => {
        console.log("reserror", resError);
        setIsLoading(false);
      }
    );
    getGroupsList(
      {},
      (res) => {
        if (res) {
          const data = res?.filter((item) => {
            const isSameCompany = item?.companyId === companyId;
            if (!isSameCompany) return false;
            return true;
          });
          setGroupList(data);
          setIsLoading(false);
        }
      },
      (resError) => {
        setIsLoading(false);
      }
    );
  };

  useEffect(() => {
    setIsLoading(true);
    clearformdata();
    setAudienceList([]);
    setAudienceName([]);
    fetchData();

    getSettings("notification_settings", (res) => {
      const userRole = auth?.userProfile?.role;
      const employeeRole = auth?.userProfile?.employeerole;
      const isFullAccess = userRole === "companyUser" || ((Array.isArray(userRole) && userRole.includes("Employee")) || userRole === "Employee" === "Employee" && (employeeRole === "Admin" || employeeRole === "Support"));

      const defaultOptions = [
        {
          label: "Push Notification",
          value: "PushNotification",
          icon: <Bell size={16} />,
          enabled: false,
        },
        {
          label: "SMS",
          value: "Push",
          icon: <MessageSquare size={16} />,
          enabled: false,
        },
        {
          label: "Email",
          value: "Email",
          icon: <Mail size={16} />,
          enabled: false,
        },
      ];

      const setOptions = (data) => {
        const updatedOptions = defaultOptions?.map((opt) => {
          let isEnabled = false;

          if (isFullAccess) {
            isEnabled = true;
          } else {
            if (opt?.value === "PushNotification") {
              isEnabled = data?.pushNotificationRoles?.includes(userRole);
            } else if (opt?.value === "Push") {
              isEnabled = hasSMSAccess && data?.smsRoles?.includes(userRole);
            } else if (opt?.value === "Email") {
              isEnabled = data?.emailRoles?.includes(userRole);
            }
          }

          return {
            ...opt,
            enabled: isEnabled,
          };
        });

        setMessageOptionsList(updatedOptions);
        setIsLoading(false);
      };

      if (res?.data?.length > 0) {
        const filteredData = res?.data?.filter(
          (item) => item?.companyId === companyId && !item.deleted
        );
        if (filteredData.length > 0) {
          setOptions(filteredData[0]);
          return;
        }
      }

      setMessageOptionsList(
        defaultOptions.map((opt) => ({ ...opt, enabled: true }))
      );
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    getaudience();
  }, [formdata?.selectedGroup]);

  useEffect(() => {
    getaudienceCli();
  }, [formdata?.selectedClient]);

  const handlefieldChange = (name, value) => {
    setFormData({
      message: formdata?.message,
      subject: formdata?.subject,
      selectedMessageType: formdata?.selectedMessageType,
      [name]: value,
    });
    setFormError({ ...formerror, [name]: "" });
    if (name === "selectedClient") {
      setGetEmpby("client");
      setGetCliby("clientt");
    }
    if (name === "selectedEmployees" && value) {
      setGetEmpby("employee");
      setAudienceList([
        ...value?.map((aitem) => {
          return {
            name: aitem.firstName,
            id: aitem.id,
            email: aitem.email,
            phone: aitem.phoneNumber,
          };
        }),
      ]);
    }
  };

  const handlefieldChangenew = (name, value) => {
    setFormData({ ...formdata, [name]: value });
    setFormError({ ...formerror, [name]: "" });
    // if (name === "selectedClient") {
    //   setGetEmpby("client");
    //   setGetCliby("clientt");
    // }
    // if (name === "selectedEmployees" && value) {
    //   setGetEmpby("employee");
    //   setAudienceList([
    //     ...value?.map((aitem) => {
    //       return {
    //         name: aitem.firstName,
    //         id: aitem.id,
    //         email: aitem.email,
    //         phone: aitem.phoneNumber,
    //       };
    //     }),
    //   ]);
    // }
  };

  const handlefieldChangenewm = (name, value) => {
    setFormData({ ...formdata, [name]: value });
    setFormError({ ...formerror, [name]: "" });
    // if (name === "selectedClient") {
    //   setGetEmpby("client");
    //   setGetCliby("clientt");
    // }
    // if (name === "selectedEmployees" && value) {
    //   setGetEmpby("employee");
    //   setAudienceList([
    //     ...value?.map((aitem) => {
    //       return {
    //         name: aitem.firstName,
    //         id: aitem.id,
    //         email: aitem.email,
    //         phone: aitem.phoneNumber,
    //       };
    //     }),
    //   ]);
    // }
  };
  const getaudienceCli = () => {
    const { selectedClient } = formdata;

    if (Array.isArray(selectedClient)) {
      let list;
      const data =
        auth?.userProfile?.role === "Client"
          ? employees?.filter((employee) =>
              employee?.clients?.some(
                (client) => client?.clientid === auth?.userProfile?.client
              )
            )
          : employees;

      const selectedClientIds = selectedClient?.map((c) => c.id);

      list = Array.isArray(data)
        ? data
            .map((aitem) => {
              const clientIds = Array.isArray(aitem?.clients)
                ? aitem.clients.map((clien) => clien?.clientid)
                : [];

              const hasMatch = clientIds?.some((id) =>
                selectedClientIds?.includes(id)
              );

              if (hasMatch) {
                return {
                  name: aitem.firstName,
                  id: aitem.id,
                  email: aitem.email,
                  phone: aitem.phoneNumber,
                };
              }

              return null;
            })
            .filter(Boolean)
        : [];

      const newlist = list?.filter((value) => Object.keys(value)?.length !== 0);

      setAudienceList(newlist);
    }
  };

  const getaudience = () => {
    const { selectedGroup } = formdata;

    if (Array.isArray(selectedGroup)) {
      let list;
      const data = employees;

      const selectedGroupIds = selectedGroup?.map((g) => g?.groupId);

      list = Array.isArray(data)
        ? data
            ?.map((aitem) => {
              const userGroups = aitem?.group || [];

              const hasMatch = userGroups?.some((id) =>
                selectedGroupIds?.includes(id)
              );

              if (hasMatch) {
                return {
                  name: aitem.firstName,
                  id: aitem.id,
                  email: aitem.email,
                  phone: aitem.phoneNumber,
                };
              }

              return null;
            })
            .filter(Boolean)
        : [];

      const newlist = list?.filter((value) => Object.keys(value)?.length !== 0);

      setAudienceList(newlist);
    }
  };

  const checkValid = () => {
    let errormessages = formerror;
    let isValid = true;
    if (typeof formdata?.message === "undefined" || formdata?.message === "") {
      isValid = false;
      toast({
        title: "Error",
        description: "Please enter a message",
        variant: "destructive",
      });
      errormessages = {
        ...errormessages,
        message: "Field is required",
      };
    } else {
      errormessages = { ...errormessages, message: "" };
    }
    if (audienceList.length <= 0) {
      isValid = false;
      toast({
        title: "Error",
        description: "Please select at least one recipient",
        variant: "destructive",
      });
      errormessages = {
        ...errormessages,
        selectedGroup: "Please Add employees By Name/By Client/By Group First!",
      };
    } else {
      errormessages = { ...errormessages, selectedGroup: "" };
    }

    if (
      typeof formdata?.selectedMessageType === "undefined" ||
      formdata?.selectedMessageType === ""
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        selectedMessageType: "Field is required",
      };
    } else {
      errormessages = { ...errormessages, selectedMessageType: "" };
    }

    setFormError(errormessages);
    return isValid;
  };

  const onSaveNotification = () => {
    if (true === checkValid()) {
      setIsLoading(true);
      if (!formdata?.selectedMessageType) {
      toast({
        title: "Error",
        description: "Please select at least one notification type",
        variant: "destructive",
      });
      }
      const allTypesPresent = ["PushNotification", "Push", "Email"].every(
        (type) => formdata?.selectedMessageType.includes(type)
      );
      let formDataSave = {
        Message: formdata?.message,
        scheduled: scheduled,
        scheduleDate: scheduled ? scheduleDate : null,
        scheduleTime: scheduled ? scheduleTime : null,
        subject: formdata?.subject,
        companyId: companyId,
        Client: Array.isArray(formdata?.selectedClient)
          ? formdata?.selectedClient?.map((client) => ({
              id: client?.id,
              name: client?.clientName,
            }))
          : [],

        Group: Array.isArray(formdata?.selectedGroup)
          ? formdata?.selectedGroup?.map((group) => ({
              id: group?.groupId,
              title: group?.title,
            }))
          : [],
        Type: allTypesPresent ? "Both" : formdata?.selectedMessageType,
        read: false,
        Employee: audienceList
          ? audienceList?.map((empitem) => {
              return {
                id: empitem.id,
                name: `${empitem.name}`,
                email: empitem.email,
                phone: empitem.phone,
              };
            })
          : [],
        MessageRecipents: audienceList
          ? audienceList?.map((aitem) => aitem.id)
          : [],
      };
      saveNotification(
        formDataSave,
        companyName,
        (res) => {
          if (res.status === true) {
            setIsLoading(false);
            toast({
            title: "Success",
            description: scheduled 
              ? "Your notification has been scheduled" 
              : "Your notification has been sent",
            variant: "default",
            });

            resetFormStates();
            history("/communications/notifications/manage");
          }
        },
        (errorRes) => {
          setIsLoading(false);
          toast({
            title: "Error",
            description: errorRes?.error?.response?.data?.error,
            variant: "destructive",
          });
          console.log("error while save notification", errorRes);
        }
      );
    }
  };

  const onScheduledChange = () => {
    setSCheduled(!scheduled);
  };

  const onScheduledDateChange = (e) => {
    setScheduleDate(e);
  };
  const onScheduledTimeChange = (e) => {
    setScheduleTime(e);
  };

  useEffect(() => {
    if (audienceList?.length > 0) {
      const data = audienceList?.map((item) => item?.name);
      setAudienceName(data);
    } else {
      setAudienceName();
    }
  }, [audienceList]);

  let allclietnoptions = [
    ...clientList?.map((item) => {
      return { label: item?.clientName, value: item, employeeCount: item?.employeeCount };
    }),
  ];
  let allgroupoptions = [
    ...groupList?.map((item) => {
      return { label: item?.title, value: item };
    }),
  ];
  let allempoptions = employeeList?.map((item) => {
    return { label: item?.firstName + item?.lastName, value: item };
  });

  const selectedNotificationTypes = formdata?.selectedMessageType || [];

  const handleNotificationTypeChange = (value) => {
    const newSelected = selectedNotificationTypes?.includes(value)
      ? selectedNotificationTypes?.filter((item) => item !== value)
      : [...selectedNotificationTypes, value];
    handlefieldChangenew("selectedMessageType", newSelected);
  };

  const handleSelectAllTypes = () => {
    const allowedTypes = messageOptionsList
      ?.filter((item) => item?.enabled)
      ?.map((item) => item.value);

    const isAllSelected = allowedTypes?.every((type) =>
      selectedNotificationTypes?.includes(type)
    );

    if (isAllSelected) {
      handlefieldChangenew("selectedMessageType", []);
    } else {
      handlefieldChangenew("selectedMessageType", allowedTypes);
    }
  };

  const options =
    type === "client"
      ? allclietnoptions
      : type === "group"
      ? allgroupoptions
      : allempoptions;

  return (
    <Container>
      <PageTitle
        pageTitle="Create Notification"
        showBreadcrumb={[{ label: "Home", to: "/" }, { label: "Notifications", to: "/communications/notifications/manage" }]}
        showLastSeen={true}
      />
      <div className="p-20">
        <div
          className={
            isMobile
              ? "d-flex flex-direction-column w-100"
              : "d-flex flex-space-between w-100"
          }
        >
          <div style={{ width: isMobile ? "100%" : "65%" }}>
            <Card
              className={`${styles.cardStyle} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}
            >
              <h3 className="p-20 d-flex flex-center">
                <RecipientType recipientType={type} />{" "}
                <span
                  style={{ fontSize: "18px", fontWeight: "600" }}
                  className="ml-8 text-foreground"
                >
                  Select Recipients
                </span>
              </h3>
              <CardContent className="ph-20 pb-20 pt-0">
                <h4
                  className="mv-5 text-foreground"
                  style={{ fontSize: "14px", fontWeight: "500" }}
                >
                  Employee by
                </h4>

                <div className="mb-16">
                  <SingleSelectNew
                    value={type}
                    name={"type"}
                    contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                    itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                    onChange={(value) => {
                      setAudienceList([]);
                      setAudienceName([]);
                      const newType = value;
                      setType(newType);

                      if (
                        formdata?.selectedEmployees ||
                        formdata?.selectedClient ||
                        formdata?.selectedGroup
                      ) {
                        setFormData((prev) => ({
                          ...prev,
                          selectedEmployees: undefined,
                          selectedClient: undefined,
                          selectedGroup: undefined,
                        }));
                      }
                    }}
                    options={TypeOptions}
                  />
                </div>

                <div>
                  <h3
                    style={{ fontSize: "14px", fontWeight: "500" }}
                    className="text-foreground"
                  >
                    Available {type === "employee" ? "Employees" : "Groups"}
                  </h3>
                  <RecipientList
                    options={options}
                    formdata={formdata}
                    recipientType={type}
                    handlefieldChange={handlefieldChange}
                  />

                  <div
                    className="mt-10 text-foreground"
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      // color: "#020817",
                    }}
                  >{`Selected Recipients (${
                    audienceName?.length > 0 ? audienceName?.length : 0
                  })`}</div>
                  {audienceName?.length === 0 && (
                    <div
                      className="mt-10"
                      style={{
                        color: "#64738B",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      No recipients selected{" "}
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>

            <Card
              className={`${styles.cardStyle} mv-30 dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}
            >
              <div
                className="d-flex flex-center"
                style={{ padding: "24px 24px 12px" }}
              >
                <ChatBubbleOutlineOutlinedIcon
                  style={{ color: "rgb(59 130 246 / 1)" }}
                  className="mr-8"
                />
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                  }}
                  className="text-foreground"
                >
                  {" "}
                  Message Details
                </span>
              </div>
              <CardContent style={{ padding: "12px 24px 24px 24px" }}>
                <div className={`${styles.container} mb-10`}>
                  <div className={styles.header}>
                    <label className={`${styles.label} dark:text-white`}>
                      Notification Types
                    </label>
                    <button
                      type="button"
                      className={styles.selectAllBtn}
                      onClick={handleSelectAllTypes}
                    >
                      {selectedNotificationTypes?.length ===
                      messageOptionsList?.length
                        ? "Deselect All"
                        : "Select All"}
                    </button>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-10">
                    {messageOptionsList?.map((type) => (
                      <div
                        key={type.value}
                        className={`flex items-center space-x-2 border rounded-md p-12 cursor-pointer ${
                          selectedNotificationTypes?.includes(type.value)
                            ? "border-blue-500 bg-blue-50 dark:bg-[#0F1729] dark:text-white"
                            : "border-gray-200 hover:border-gray-300"
                        }`}
                        onClick={() => {
                          if (type?.enabled) {
                            handleNotificationTypeChange(type.value);
                          }
                        }}
                      >
                        <Checkbox
                          id={`type-${type.id}`}
                          checked={selectedNotificationTypes?.includes(
                            type.value
                          )}
                          disabled={!type.enabled}
                          onCheckedChange={() =>
                            type.enabled &&
                            handleNotificationTypeChange(type.value)
                          }
                        />
                        <div className="flex flex-1 items-center">
                          <label className="flex items-center gap-2 cursor-pointer">
                            <span className="mr-5 dark:text-white">
                              {type?.icon}
                            </span>{" "}
                            <span className="dark:text-white">
                              {type?.label}
                            </span>
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>

                  {selectedNotificationTypes?.length === 0 && (
                    <p className="color-danger">
                      Please select at least one notification type
                    </p>
                  )}
                </div>

                <Typography
                  variant="body"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                  className="text-[#020817] dark:text-white"
                >
                  Subject
                </Typography>
                <div className="mt-8 mb-12">
                  <Input
                    id="subject"
                    placeholder="Enter notification subject"
                    className="mt-1"
                    value={formdata?.subject ? formdata?.subject : ""}
                    onChange={(e) =>
                      handlefieldChangenewm("subject", e.target.value)
                    }
                  />
                </div>

                <Typography
                  variant="body"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                  className="text-[#020817] dark:text-white"
                >
                  Message
                </Typography>
                <div className="mt-8 mb-12">
                  <Textarea
                    id="message"
                    placeholder="Type your message here"
                    className="mt-1 min-h-[150px]"
                    value={formdata?.message ? formdata?.message : ""}
                    onChange={(e) =>
                      handlefieldChangenewm("message", e.target.value)
                    }
                  />
                </div>

                <div className={styles.scheduleContainer}>
                  <div className={styles.scheduleHeader}>
                    <div className={styles.scheduleLeft}>
                      <AccessTimeOutlinedIcon className={styles.clockIcon} />
                      <h4
                        htmlFor="scheduled"
                        className="text-[#020817] dark:text-white"
                      >
                        Schedule for later
                      </h4>
                    </div>
                    <AntSwitch
                      checked={scheduled}
                      onChange={onScheduledChange}
                      color="primary"
                      name="switchStatus"
                      inputProps={{ "aria-label": "switchStatus" }}
                    />
                  </div>

                  {scheduled && (
                    <div className={styles.scheduleGrid}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <div>
                          <h4
                            htmlFor="date"
                            className="mv-5 text-[#020817] dark:text-white"
                          >
                            Date
                          </h4>
                          <DatePicker
                            value={scheduleDate ? moment(scheduleDate) : null}
                            onChange={(newValue) => {
                              onScheduledDateChange(newValue ? newValue.format("YYYY-MM-DD") : "");
                            }}
                            disablePast={true}
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                className: "customDateInput",
                              },
                            }}
                          />
                        </div>

                        <div>
                          <h4
                            htmlFor="time"
                            className="mv-5 text-[#020817] dark:text-white"
                          >
                            Time
                          </h4>
                          <TimePicker
                            value={scheduleTime ? moment(scheduleTime, "HH:mm") : null}
                            onChange={(newValue) => {
                              onScheduledTimeChange(newValue ? newValue.format("HH:mm") : "");
                            }}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                sx: {
                                  "& .MuiInputBase-input": {
                                    height: "30px",
                                    color: "white",
                                    backgroundColor: "transparent",
                                  },
                                  "& .MuiOutlinedInput-root": {
                                    height: "40px",
                                    borderRadius: "8px",
                                  },
                                },
                                className: `${styles.inputField} dark:text-white dark:bg-[#0F1729]`,
                              },
                            }}
                          />
                        </div>
                      </LocalizationProvider>
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          </div>
          <div style={{ width: isMobile ? "100%" : "32%" }}>
            <Card
              className={`${styles.card} ${styles.cardStyle} mv-30 dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}
              style={{ minWidth: "100%" }}
            >
              <div className={styles.cardHeader}>
                <div className={styles.cardTitle}>
                  <NotificationsNoneOutlinedIcon
                    size={18}
                    className={styles.notificationIcon}
                  />
                  <span className="dark:text-white">Notification Preview</span>
                </div>
              </div>

              <CardContent style={{ padding: "0px 24px 24px 24px" }}>
                <div className={styles.contentWrapper}>
                  <div className={styles.section}>
                    <h3 className={styles.sectionTitle}>Notification Types</h3>
                    <div className={styles.badgeContainer}>
                      {selectedNotificationTypes?.includes("Email") && (
                        <Badge className={styles.emailBadge}>
                          <EmailOutlinedIcon fontSize="small" /> Email
                        </Badge>
                      )}
                      {selectedNotificationTypes?.includes("Push") && (
                        <Badge className={styles.smsBadge}>
                          <ChatBubbleOutlineOutlinedIcon fontSize="small" /> SMS
                        </Badge>
                      )}
                      {selectedNotificationTypes?.includes(
                        "PushNotification"
                      ) && (
                        <Badge className={styles.pushBadge}>
                          <NotificationsNoneOutlinedIcon fontSize="small" />{" "}
                          Push
                        </Badge>
                      )}
                      {selectedNotificationTypes?.length === 0 && (
                        <span className={styles.emptyText}>
                          No notification types selected
                        </span>
                      )}
                    </div>
                  </div>

                  <div className={styles.section}>
                    <h3 className={styles.sectionTitle}>Subject</h3>
                    <div className={`${styles.box} dark:bg-[#0F1729]`}>
                      {formdata?.subject ? (
                        <span className="dark:text-white">
                          {formdata?.subject}
                        </span>
                      ) : (
                        <span className={`${styles.emptyText} dark:text-white`}>
                          No subject
                        </span>
                      )}
                    </div>
                  </div>

                  <div className={styles.section}>
                    <h3 className={styles.sectionTitle}>Message</h3>
                    <div
                      className={`${styles.box} ${styles.messageBox} dark:bg-[#0F1729]`}
                    >
                      {formdata?.message ? (
                        <span className="dark:text-white">
                          {formdata?.message}
                        </span>
                      ) : (
                        <span className={`${styles.emptyText} dark:text-white`}>
                          No message
                        </span>
                      )}
                    </div>
                  </div>

                  <div className={styles.section}>
                    <h3 className={styles.sectionTitle}>
                      Recipients (
                      {audienceName?.length > 0 ? audienceName?.length : 0})
                    </h3>
                    <div className={styles.badgeContainer}>
                      {audienceName?.length > 0 ? (
                        audienceName?.slice(0, 3).map((recipient) => (
                          <Badge
                            key={recipient}
                            variant="outline"
                            className={`${styles.recipientBadge} dark:text-white`}
                          >
                            <PersonOutlineOutlinedIcon fontSize="small" />{" "}
                            {recipient}
                          </Badge>
                        ))
                      ) : (
                        <span className={styles.emptyText}>
                          No recipients selected
                        </span>
                      )}
                      {audienceName?.length > 3 && (
                        <Badge
                          variant="outline"
                          className={`${styles.recipientBadge} dark:text-white`}
                        >
                          <PersonOutlineOutlinedIcon fontSize="small" /> +
                          {audienceName?.length - 3} more
                        </Badge>
                      )}
                    </div>
                  </div>

                  <div className={styles.section}>
                    <h3 className={styles.sectionTitle}>Delivery</h3>
                    <div className={styles.deliveryInfo}>
                      {scheduled ? (
                        <>
                          <AccessTimeOutlinedIcon
                            fontSize="small"
                            className={styles.clockIcon}
                          />
                          <span className="dark:text-white">
                            {`Scheduled for  ${scheduleDate} - ${scheduleTime}`}
                          </span>
                        </>
                      ) : (
                        <>
                          <Badge className={styles.immediateBadge}>
                            Immediate
                          </Badge>
                          <span className={styles.deliveryText}>
                            Will be sent immediately
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
        <div className="ph-12">
          <Grid container className="buttonwrap mv-15">
            <Grid item sm={12} md={12}>
              <Button
                variant="contained"
                color={messageOptionsList.length > 0 ? "primary" : ""}
                className="themebutton flatbutton mr-12"
                onClick={onSaveNotification}
                style={{ borderRadius: "4px" }}
                disabled={messageOptionsList.length === 0}
              >
                Send Notification
              </Button>
              <Button
                color="primary"
                variant="contained"
                style={{ borderRadius: "4px" }}
                className="themebutton flatbutton mr-12"
                onClick={clearformdata}
              >
                Reset
              </Button>
              <Button
                variant="contained"
                style={{ borderRadius: "4px" }}
                className="themebutton flatbutton "
                onClick={async () => {
                  try {
                    const result = await confirm(
                      "Are you sure you want to cancel? This won't be saved or sent."
                    );

                    if (result) {
                      history("/communications/notifications/manage");
                    }
                  } catch (err) {
                    console.log("Dialog closed or error:", err);
                  }
                }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </Container>
  );
}

export default CreateNotification;
